import { Arrow } from './ui'
import { useViewportVideo } from './useViewportVideo'
import VideoSoundControl from './VideoSoundControl'
import VideoPoster from './VideoPoster'

export default function DoctorInvitation() {
  const { error, videoProps, previewProps, controlsProps } = useViewportVideo('/images/dr-nok-invitation-poster.jpg')

  return <figure className="doctor-invitation" aria-labelledby="doctor-invitation-title">
    <div className="doctor-video-frame">
      <video {...videoProps} className="doctor-video" width="720" height="1280" aria-label="วิดีโอคุณหมอนก ชวนสมัคร EMPRESS OF WELLNESS">
        <source src="/videos/dr-nok-invitation.mp4" type="video/mp4" />
        เบราว์เซอร์นี้ไม่รองรับวิดีโอ <a href="/videos/dr-nok-invitation.mp4">เปิดวิดีโอคุณหมอนก</a>
      </video>
      <VideoPoster {...previewProps} />
    </div>
    <VideoSoundControl {...controlsProps} />
    <figcaption>
      <div><span className="doctor-video-label">A PERSONAL INVITATION</span><strong id="doctor-invitation-title">คุณหมอนก ชวนสมัคร EMPRESS</strong></div>
      <a href="/videos/dr-nok-invitation.mp4" target="_blank" rel="noopener noreferrer" aria-label="เปิดวิดีโอคุณหมอนกในแท็บใหม่"><Arrow /></a>
    </figcaption>
    {error && <p className="doctor-video-error" role="alert">วิดีโอยังไม่เริ่มเล่น ลองกดเล่นจากแถบควบคุม หรือ <a href="/videos/dr-nok-invitation.mp4" target="_blank" rel="noopener noreferrer">เปิดวิดีโอโดยตรง</a></p>}
  </figure>
}
